import { Component, effect, ChangeDetectionStrategy } from '@angular/core';
import { Realm, Endpoint, Import, Syndicate, Cast, RegistryEntry } from '@xanadu/model';
import { NodeComponent } from '@xanadu/core';


@Component({
    selector: 'app-import-node',
    templateUrl: './import-node.component.html',
    styleUrls: ['./import-node.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ImportNodeComponent extends NodeComponent {
    protected get nodeType(): string | undefined {
        return 'import';
    }

    private iconRoot = 'account_tree';
    private iconRealm = 'cloud_circle';
    private iconEndpoint = 'cloud_download';
    private iconSyndicate = 'rule_folder';
    private iconCast = 'rule';

    constructor(
    ) {
        super();

        effect(() => {
            const model = this.model();

            if (model) {
                if (model.node instanceof Import) {
                    this.icon = this.iconRoot;
                } else if (model.node instanceof Realm) {
                    this.icon = this.iconRealm;
                } else if (model.node instanceof Endpoint) {
                    this.icon = this.iconEndpoint;
                } else if (model.node instanceof Syndicate) {
                    this.icon = this.iconSyndicate;
                } else if (model.node instanceof Cast) {
                    this.icon = this.iconCast;
                }
            }
        });
    }
}
